<i18n src="./resources/locales.json"></i18n>
<template>
  <div class="actions-section" :style="emojiStyle">
    <emoji-picker
      v-if="showEmojiPicker"
      class="emoji-picker-selection"
      title="Pick your emoji..."
      emoji="point_up"
      @emoji-click="handleSelectedEmoji"
      ref="emojiPicker"
    />
    <SmsGiphyContainer v-show="showGifPicker" />
    <v-btn icon :disabled="disabled" @click="openEmojiPicker">
      <v-icon>mdi-emoticon-outline</v-icon>
    </v-btn>
    <v-btn icon :disabled="disabled" @click="openGif()" ref="gifButton">
      <v-icon>mdi-gif</v-icon>
    </v-btn>
    <v-btn icon :disabled="disabled" @click="loadNewFile()">
      <v-icon>mdi-image</v-icon>
    </v-btn>
    <v-btn icon :disabled="disabled" @click="openSelectContactsToShare()">
      <v-icon>mdi-share-variant</v-icon>
    </v-btn>

    <v-btn icon class='group-message-icon' :class='{"icon-selected-background": this.groupMode}' :disabled="disabled" @click="setToGroupMessage()"
           v-if="!this.activeConversation && this.hasMultipleRecipients">
      <v-icon>mdi-account-multiple</v-icon>
      <div> {{groupMode ? $t('group') : $t('bulk')}}</div>
    </v-btn>

    <v-btn
      id="sms-send-new-message-btn"
      ref="sendButton"
      icon
      class="send-icon"
      :disabled="disabled"
      @click="sendMessage($event)"
      >
      <v-icon>mdi-send</v-icon>
    </v-btn>
    <!-- Hidden File Input -->
    <input id="uploadCaptureInputFile" ref="fileInput" type="file" accept="image/jpeg,image/png,image/gif" @change="handleChange" hidden />
  </div>
</template>
<script>
import SmsGiphyContainer from './SmsGiphyComponents/SmsGiphyContainer';
// eslint-disable-next-line
import emojiPicker from 'emoji-picker-element';
import { mapGetters } from 'vuex';
import ThemeMixin from '@/mixins/ThemeMixin';

export default {
  name: 'SmsActionsFooter',

  components: { SmsGiphyContainer },

  props: {
    sendMessageConversation: { type: Function },
    disabled: {
      type: Boolean,
      default: false
    },
    groupMode: {
      type: Boolean,
      default: false
    }
  },

  mixins: [ThemeMixin],

  data() {
    return {
      file: null,
      contactSelectionOpen: false,
      messageText: '',
      showEmojiPicker: false,
      showGifPicker: false,
      hasMultipleRecipients: false
    };
  },

  computed: {
    ...mapGetters('themes', ['selectedThemeName']),
    ...mapGetters('conversationsV2', [
      'activeConversation',
      'getConversationById',
    ]),
    emojiStyle() {
      let emojiStyleVariables = { '--hover-color': '#d9d9d9', '--input-font-color': '#111' };

      if (this.selectedThemeName === 'dark') {
        emojiStyleVariables = { '--hover-color': '#484848', '--input-font-color': '#efefef' };
      }
      if (this.selectedThemeName === 'contrast') {
        emojiStyleVariables = { '--hover-color': 'var(--v-primary-button-hover-base)', '--input-font-color': '#efefef' };
      }
      return emojiStyleVariables;
    }
  },

  created() {
    this.$root.$on('close-pickers', this.closePickers);
    this.$root.$on('new-message-recipients-list-change', this.setNewMessageRecipients);
  },

  beforeDestroy() {
    this.$root.$off('new-message-recipients-list-change');
  },

  methods: {
    sendMessage(event) {
      this.sendMessageConversation(event);
    },
    handleChange(event) {
      event.preventDefault();
      const newFile = event.target?.files[0];
      if (newFile)
        this.$root.$emit('on-load-file', newFile);
    },
    openEmojiPicker() {
      this.showEmojiPicker = !this.showEmojiPicker;
      this.showGifPicker = false;
      setTimeout(() => {
        this.setEmojiPickerStyle();
      }, 25);
    },
    handleSelectedEmoji(emoji) {
      this.$emit('emoji-select', emoji);
      this.showEmojiPicker = !this.showEmojiPicker;
    },
    openGif() {
      this.showGifPicker = !this.showGifPicker;
      this.showEmojiPicker = false;
    },
    closePickers() {
      this.showEmojiPicker = false;
      this.showGifPicker = false;
      this.$root.$emit('clear-gif-search');
    },
    loadNewFile() {
      document.getElementById('uploadCaptureInputFile').value = '';
      this.$refs.fileInput.click()
    },
    openSelectContactsToShare() {
      this.$root.$emit('select-contacts-to-share');
    },
    setToGroupMessage(){
      this.$root.$emit('toggle-group-message-mode');
    },
    setNewMessageRecipients(recipients){
      if(recipients && recipients.length > 1){
        this.hasMultipleRecipients = true;
      } else {
        this.hasMultipleRecipients = false;
        if(this.groupMode){
          this.$root.$emit('toggle-group-message-mode');
        }
      }
    },
    setEmojiPickerStyle() {
      // Work Around to change text according locale in emoji picker
      this.$refs.emojiPicker.shadowRoot.querySelector('#search').placeholder = this.$t('emojiPickerSearch');
      const style = document.createElement('style');
      style.textContent = this.getCustomScrollStyle();
      this.$refs.emojiPicker.shadowRoot.appendChild(style);
    }
  }
};
</script>
<style scoped>
.send-icon {
  float: right;
  right: -6px;
}
.icon-selected-background {
  background: rgba(0, 0, 0, 0.54);
  color: #fff!important;
}
.emoji-picker-selection {
  position: absolute;
  bottom: 40px;
  background-color: var(--v-surface2-base) !important;
  border: solid 1px var(--v-surface-border-base) !important;
}
.actions-section {
  max-width: 800px;
  margin: 8px auto;
}
emoji-picker {
  --background: '';
  --button-hover-background: var(--hover-color);
  --input-font-color: var(--input-font-color);
  z-index: 1;
}
</style>
<style>
.emoji-mart-category-label > span {
  background-color: var(--v-surface2-base) !important;
  color: var(--v-secondary-lighten1) !important;
}
.group-message-icon {
  width: auto!important;
  border-radius: .5em;
  margin: 0 4px;
  padding: 3px;
}
</style>
